import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {UserProgress} from "../api-course-data/user-state-dto";
import {UserStateProvider} from "../user-state/user-state";
import {AlertController, Events} from "ionic-angular";
import {ContentTranslationProvider} from "../content-translation/content-translation";
import {AppVideoPlayerPage} from "../../pages/app-video-player/app-video-player";
import {ApiCourseDataProvider} from "../api-course-data/api-course-data";
import {CourseVideo} from "../../models/course-video";

/*
  Generated class for the ApiUserProgressProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiUserProgressProvider {

  constructor(public api: ApiProvider, public state: UserStateProvider, public events: Events, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider) {
    this.events.subscribe('state:refreshed', (courseData: ApiCourseDataProvider) => {
      courseData.getAddtionalVideos().map(video =>  {
        if(video._userStatus == 1) {
          this.updateVideoPlusStatus(video.id, 2).then();
          this.newVideoPending = video;
          this.checkIfBonusVideoIsAvailable();
        }
      });
    });

  }

  showFinalAlert() {
    let insuranceData = this.state.user.insurance;

    if(!insuranceData.firstName || !insuranceData.lastName) {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Certificate Request NON AOK Title').replace('{name}', this.state.user.firstName),
        subTitle: this.contentTranslation.translateContent('Certificate Request NON AOK Text').replace('{name}', this.state.user.firstName),
        inputs: [
          {
            name: 'firstName',
            placeholder: this.contentTranslation.translateContent('First Name'),
          },
          {
            name: 'lastName',
            placeholder: this.contentTranslation.translateContent('Last Name'),
          },
        ],
        buttons: [
          {
            text: this.contentTranslation.translateContent('OKAY'),
            handler: (data) => {
              if(!data.firstName || !data.lastName) {
                return false;
              }
              this.api.callPost('/users/'+this.state.user.id+'/certificate', data).subscribe();

            }
          }

        ],
        cssClass: 'ip-alert ip-with-close ip-stage-completed-popup ip-stage-post-final ip-stage-post-final-non-aok',
      });
      alert.present();
    } else {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Certificate Request AOK Title').replace('{name}', this.state.user.firstName),
        subTitle: this.contentTranslation.translateContent('Certificate Request AOK Text').replace('{name}', this.state.user.firstName),
        buttons: [
          {
            text: this.contentTranslation.translateContent('OKAY'),
            handler: () => {
              this.api.callPost('/users/'+this.state.user.id+'/certificate', {}).subscribe();

            }
          }

        ],
        cssClass: 'ip-alert ip-with-close ip-stage-completed-popup ip-stage-post-final ip-stage-post-final-aok',
      });
      alert.present();
    }
  }

  showLastModuleEndPopup() {
    const alert = this.alertCtrl.create({
      title: '<img src="/assets/imgs/popup-success-icon-8.png" />'+this.contentTranslation.translateContent('Stage last closed title').replace('{name}', this.state.user.firstName),
      subTitle: this.contentTranslation.translateContent('Stage last closed text').replace('{name}', this.state.user.firstName),
      buttons: [
        {
          text: this.contentTranslation.translateContent('OKAY')
        }

      ],
      cssClass: 'ip-alert ip-with-close ip-stage-completed-popup ip-final-stage-completed-popup'
    });
    alert.present();

  }

  newModulePopupOpened: boolean = false;
  newVideoPending: CourseVideo = null;

  updateProgress(userProgress: UserProgress) {
    var me = this;

    return new Promise((resolve, reject) => {

      if(userProgress.isFinished() && userProgress.video && userProgress.video.module && userProgress.video.position < 3) {
        let video = userProgress.video;
        let module = video.module;
        let currentVideoPosition = video.position;
        module.videos.filter(video => {
          if(video.position == currentVideoPosition + 1) {
            video._userStatus = 2;
            this.events.publish('state:refreshed-locally');
          }
        })
      }

      let currentModuleBeforeUpdate = userProgress.video.module.position;

      me.api.callPut<UserProgress>('/progresses/'+userProgress.videoId, userProgress.toJSON()).subscribe(
        res => {


          if(res.stateRefreshRequired) {
            this.events.publish('state:refresh');
          }

          if(res.locked) {
            this.state.user.locked = true;
          }

          if(res.stateModuleClosed || res.stateNewModuleUnlocked) {
            this.events.publish('module:finished', {position: currentModuleBeforeUpdate});
          }

          if(res.stateModuleClosed) {
            if(!res.stateNewModuleAvailableInDays) {

              this.showLastModuleEndPopup();
              return ;
            }

            let days = (8 - new Date().getUTCDay());
            if(days == 8) {
              days = 1;
            }

            this.newModulePopupOpened = true;

            const alert = this.alertCtrl.create({
              title: '<img src="/assets/imgs/popup-success-icon-'+userProgress.video.module.position+'.png" />'+this.contentTranslation.translateContent('Stage closed title'),
              subTitle: this.contentTranslation.translateContent('Stage %num% closed content. New stage available in %days%').replace('%num%', (userProgress.video.module.position).toString()).replace('%days%', res.stateNewModuleAvailableInDays.toString()),
              buttons: [
                {
                  text: this.contentTranslation.translateContent('WEITER GEHT`S'),
                  handler: _ => {
                    this.newModulePopupOpened = false;
                    this.checkIfBonusVideoIsAvailable()
                  }
                }

              ],
              cssClass: 'ip-alert ip-with-close ip-stage-completed-popup ip-normal-stage-completed-popup'
            });
            alert.present();
          }


          if(res.stateNewModuleUnlocked) {
            const alert = this.alertCtrl.create({
              title: '<img src="/assets/imgs/popup-success-icon-'+userProgress.video.module.position+'.png" />'+this.contentTranslation.translateContent('Stage closed title'),
              subTitle: this.contentTranslation.translateContent('Stage %num% closed content. New stage is available now').replace('%num%', (userProgress.video.module.position).toString()),
              buttons: [
                {
                  text: this.contentTranslation.translateContent('WEITER GEHT`S'),
                  handler: _ => {
                    this.newModulePopupOpened = false;
                    this.checkIfBonusVideoIsAvailable()
                  }
                },
              ],
              cssClass: 'ip-alert ip-with-close ip-stage-completed-popup ip-normal-stage-completed-popup'
            });
            alert.present();
          }


          resolve(res)
        },
        res => {
          console.log(res);
          reject(res)
        }
      )
    })
  }

  checkIfBonusVideoIsAvailable() {
    console.log('check bonus video', this);
    if(this.newModulePopupOpened) {
      return ;
    }
    if(this.newVideoPending) {
      const video = this.newVideoPending;
      this.newVideoPending = null;
      const alert = this.alertCtrl.create({
        title: '',
        subTitle: "<img src='/assets/imgs/icon-gift-2.svg' />"+this.contentTranslation.translateContent('Bonus video available content'),
        buttons: [
          {
            text: this.contentTranslation.translateContent('ZUM VIDEO'),
            handler: () => {
              console.log('trigger open video plus');
              this.events.publish('app:open-video-plus', {video: video});
            },
            cssClass: 'alert-primary-button',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }
        ],
        cssClass: 'ip-alert ip-with-close ip-dynamic-height ip-new-video-plus'
      });
      alert.present();
    }

  }

  updateVideoPlusStatus(id: string, status: number) {
    var me = this;

    return new Promise((resolve, reject) => {
      me.api.callPut<UserProgress>('/users/'+me.state.user.id+'/plusVideoUpdate', {id: id, status: status}).subscribe(
        res => {
          resolve(res)
        },
        res => {
          reject(res)
        }
      )
    })
  }


  triggerProgressUpdate() {
    var me = this;

    return new Promise((resolve, reject) => {
      me.api.callPost<UserProgress>('/users/'+me.state.user.id+'/triggerProgressUpdate', {}).subscribe(
        res => {
          resolve(res)
        },
        res => {
          reject(res)
        }
      )
    })

  }
}



// WEBPACK FOOTER //
// ./src/providers/api-user-progress/api-user-progress.ts